var map = {
	"./pr-1.png": "effc",
	"./pr-2.png": "31c2",
	"./pr-3.png": "fbd0",
	"./pr-4.png": "c03b",
	"./pr-5.png": "60b8",
	"./pr-6.png": "8664",
	"./pr-7.png": "194a",
	"./pr-8.png": "409f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40b0";